import P18ReportComponent from 'components/Report/P18Report';
import PermissionGuard from 'components/Global/PermissionGuard'; // adjust path if needed

const P18Report = () => {
	return (
		<PermissionGuard permission="Allow_Payroll_Reports">
			<P18ReportComponent />
		</PermissionGuard>
	);
};

export default P18Report;
